export enum SiteStatus {
  ACTIVE = 'active',
  DEACTIVATED = 'inactive',
}

export const SiteTabStatus: { [key: number]: string } = {
  0: 'active',
  1: 'inactive',
};
